module.exports = __webpack_public_path__ + "img/DE00323.7156cef4.png";